module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.company != null) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.name.$error
    }
  }, [_c('label', [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter company name"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }, function($event) {
        return _vm.$v.company.name.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.name.required && _vm.$v.company.name.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Company name is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.address.$error
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.address),
      expression: "company.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.company.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "address", $event.target.value)
      }, function($event) {
        return _vm.$v.company.address.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.address.required && _vm.$v.company.address.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Address is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.website.$error
    }
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.website),
      expression: "company.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.website)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "website", $event.target.value)
      }, function($event) {
        return _vm.$v.company.website.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.website.required && _vm.$v.company.website.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Website is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.phoneNumber.$error
    }
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.phoneNumber),
      expression: "company.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.phoneNumber)
    },
    on: {
      "blur": function($event) {
        return _vm.$v.company.phoneNumber.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.$v.company.phoneNumber.required && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number is required\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.numeric && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must be a number\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.minLength && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must have at least 8 digits\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCompany
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Edit company\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24232d8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Company/EditCompanyModal.vue
// module id = 2040
// module chunks = 0